import React from "react";

export default function PageHero({ image, eyebrow, title, subtitle, children, testId = "page-hero", tall = false }) {
  return (
    <div data-testid={testId}
      className={`relative overflow-hidden rounded-3xl bg-pp-forest text-white pp-shadow-lg pp-fade-up ${tall ? "min-h-[220px] sm:min-h-[260px]" : "min-h-[160px]"}`}>
      <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#075B3A]/95 via-[#075B3A]/75 to-[#075B3A]/20" />
      <div className="relative p-6 sm:p-8 max-w-2xl">
        {eyebrow && <p className="text-white/80 text-xs sm:text-sm font-bold uppercase tracking-wider">{eyebrow}</p>}
        <h1 className="mt-1 text-3xl sm:text-4xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="mt-2 text-white/85 text-sm sm:text-base">{subtitle}</p>}
        {children && <div className="mt-4">{children}</div>}
      </div>
    </div>
  );
}
